import {
  Button,
  Card,
  Flex,
  Form,
  Input,
  Modal,
  Switch,
  Row,
  Col,
  Typography,
  Space,
} from "antd";
import React, { useRef, useState } from "react";
import { CustomTitle } from "../../../../common/customTitle";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { useTranslation } from "react-i18next";
import TextArea from "antd/es/input/TextArea";
import { checkIfFileTypeIsValidForImageAttachment, sanitizeDataTypeClientSide } from "../../../../../utils/utils";
import { useEffect } from "react";
import Actions from "../../../../../redux/actions";
import {
  createCategoryAction,
  getCategoryByIdAction,
  updateCategoryAction,
} from "../../../../../redux/services/categories/categoriesServices";
import { FileAttachment } from "../../../../common/fileAttachment";
import { CameraOutlined } from "@ant-design/icons";
import { fileImageUpload } from "../../../../../redux/services/auth/authServices";
import { toastService } from "../../../../common/toast-messages/toast";
import { colors } from "../../../../../constants/colors";

const CategoriesFormDialog = ({ open, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { selectedcategoryId } = useSelector((state) => state.categories);
  const [singleAttachmentObj, setSingleAttachmentObj] = useState(null);
  const [singleAttachmetSelectedImageUrl, setSingleAttachmetSelectedImageUrl] =
    useState("");
  const [subCategories, setSubCategories] = useState([
    { name: "", name_ar: "" }, // Initial empty subcategory
  ]);

  const attachmentRef = useRef(null);

  useEffect(() => {
    if (
      selectedcategoryId &&
      selectedcategoryId !== "" &&
      selectedcategoryId !== null &&
      selectedcategoryId !== undefined
    ) {
      const dataToBeSent = {
        selectedcategoryId,
      };
      setLoading(true);
      dispatch(getCategoryByIdAction(dataToBeSent)).then((apiRes) => {
        const subCategoryLocales = apiRes?.subcategories?.map(
          (subCategory) => ({
            ...subCategory,
            name: subCategory.name,
            name_ar: subCategory?.locales?.[0].name,
          })
        );
        setSubCategories(subCategoryLocales);

        form.setFieldsValue({
          categoryName: apiRes?.name || "",
          categoryName_ar: apiRes?.locales?.[0]?.name || "",
          isMedical: apiRes?.isMedical || false,
          isActive: apiRes?.is_active || false,
          subCategories: subCategoryLocales.map((item, index) => ({
            ...item,
            key: index, // Unique key for each item in the list
          })),
        });
        setSingleAttachmetSelectedImageUrl(apiRes?.image_url);
        setLoading(false);
      });
    }

    return () => {
      form.resetFields();
      setSubCategories([{ name: "", name_ar: "" }]);
      form.setFieldsValue({
        subCategories: [{ name: "", name_ar: "" }],
      });
    };
  }, [open]);

  const handleDialogClose = () => {
    onClose();
    setSingleAttachmetSelectedImageUrl("");
    setSingleAttachmentObj(null);
    form.resetFields();
    setSubCategories([{ name: "", name_ar: "" }]);
    form.setFieldsValue({
      subCategories: [{ name: "", name_ar: "" }],
    });
    dispatch(
      Actions.createAction(Actions.SELECTED_CATEGORIES_ID, {
        selectedcategoryId: "",
      })
    );
    dispatch(
      Actions.createAction(Actions.GET_CATEGORIES_BY_ID, { categories: {} })
    );
  };

  const onSubmit = (values) => {
    if (
      !singleAttachmetSelectedImageUrl &&
      singleAttachmetSelectedImageUrl === ""
    ) {
      toastService.error(t("pleaseSelectAnImage"));
      return;
    }

    const dataToBeSent = {
      name: values?.categoryName,
      name_ar: values?.categoryName_ar,
      subcategories: subCategories,
      isMedical: false,
      is_active: values?.isActive,
      image_url: singleAttachmetSelectedImageUrl,
    };

    if (
      selectedcategoryId &&
      selectedcategoryId !== "" &&
      selectedcategoryId !== null &&
      selectedcategoryId !== undefined
    ) {
      dataToBeSent._id = selectedcategoryId;
      dispatch(updateCategoryAction(dataToBeSent)).then(() => {
        handleDialogClose();
      });
    } else {
      dispatch(createCategoryAction(dataToBeSent)).then(() => {
        handleDialogClose();
      });
    }
  };

  const onImageChanged = (e) => {
    const file = e.target.files[0];

    const attachmentFileName = file.name;

    const fileTypeIsValidRes = checkIfFileTypeIsValidForImageAttachment(attachmentFileName);

    if (fileTypeIsValidRes.isValid === false) {
      toastService.error(fileTypeIsValidRes.isInvalidMessage);
    } else {
      setSingleAttachmentObj(file);
    if (file) {
      const formData = new FormData();
      formData.append("image", file);
      let formDataBody = formData;
      setLoading(true);
      dispatch(fileImageUpload(formDataBody)).then((apiRes) => {
        const imageUrl = apiRes?.[0];
        setSingleAttachmetSelectedImageUrl(imageUrl);
        setLoading(false);
      });
    }
    }
  };

  const onSubCategoryChange = (index, field, value) => {
    const updatedSubCategories = [...subCategories];
    updatedSubCategories[index][field] = value;
    setSubCategories(updatedSubCategories);
  };

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
      style={{ top: 20 }}
      width={800}
    >
      <CustomTitle textDecoration="underline" justifyContent="center">
        {selectedcategoryId &&
        selectedcategoryId !== "" &&
        selectedcategoryId !== null &&
        selectedcategoryId !== undefined
          ? t("editCat")
          : t("addCat")}
      </CustomTitle>
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        requiredMark={false}
        onFinish={onSubmit}
        style={{ margin: "2rem" }}
        key={selectedcategoryId || 0}
      >
        <Flex vertical gap="2rem">
          <Flex vertical gap="2rem" align="center">
            <Flex
              vertical
              align="center"
              justify="center"
              style={{ position: "relative" }}
            >
              <FileAttachment
                attachmentObj={singleAttachmentObj}
                attachmentUrl={singleAttachmetSelectedImageUrl}
                loading={loading}
              />
              <div
                className="attachmentContainer"
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  bottom: "-25px",
                   background:colors.turquoiseGreen,
                  borderRadius:10,
                }}
                onClick={() => attachmentRef.current?.click()}
              >
                <Button
                  type="primary"
                  shape="circle"
                  size="middle"
                  style={{ background:colors.turquoiseGreen}}
                  icon={<CameraOutlined style={{ fontSize: "22px" }} />}
                />
              </div>
              <input
                type="file"
                style={{ display: "none" }}
                ref={attachmentRef}
                accept="image/*"
                onChange={onImageChanged}
              />
            </Flex>
            <div>
              <Typography.Title level={3} type="secondary">
                {t("CommonUtils.supportedImageFormats")}
              </Typography.Title>
              <Typography.Title
                level={4}
                type="success"
                style={{ margin: 0, textAlign: "center", color:colors.turquoiseGreen }}
              >
                {t("CommonUtils.addImagesInParticular")}
                <br />
                {t("CommonUtils.dimension3")}
              </Typography.Title>
            </div>
          </Flex>
          <Card bordered>
          <Row justify="start" gutter={[16,16]}>
            <Col span={12}> 
            <Form.Item
              style={{ width: "100%" }}
              name="categoryName"
              label={<RequiredLabel text={t("categoryName")} required={true} />}
              rules={[
                {
                  required: true,
                  message: t("validations.category"),
                },
                {
                  whitespace: true,
                  message: t("categoryNameCannotBeEmpty"),
                },
              ]}
              normalize={(value) => sanitizeDataTypeClientSide(value)}
            >
              <Input placeholder={t("categoryName")} />
            </Form.Item>
              </Col>
              <Col span={12}> 
            <Form.Item
              style={{ width: "100%" }}
              name="categoryName_ar"
              label={
                <RequiredLabel
                  dir="rtl"
                  text={`${t("categoryName")} ${t("CommonUtils.inArabic")}`}
                  required={true}
                />
              }
              rules={[
                {
                  required: true,
                  message: `${t("validations.category")} ${t(
                    "CommonUtils.inArabic"
                  )}`,
                },
                {
                  whitespace: true,
                  message: `${t("categoryNameCannotBeEmpty")} ${t(
                    "CommonUtils.inArabic"
                  )}`,
                },
              ]}
              normalize={(value) => sanitizeDataTypeClientSide(value)}
            >
              <Input
                dir="rtl"
                placeholder={`${t("categoryName")} ${t(
                  "CommonUtils.inArabic"
                )}`}
              />
            </Form.Item>
            </Col>
            </Row>
            <Form.Item
              label={
                <RequiredLabel text={t("subCategories")} required={true} />
              }
              name="subCategories"
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: t("validations.sub"),
                },
              ]}
            >
              <Form.List
                name="subCategories"
                initialValue={subCategories.map((item) => ({ ...item }))}
                rules={[
                  {
                    validator: async (_, value) => {
                      if (!value || value.length < 1) {
                        return Promise.reject(
                          new Error("At least one subcategory is required")
                        );
                      }
                    },
                  },
                ]}
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field, index) => (
                        <Row justify="start" gutter={[16,16]} key={field.key}>
                          <Col span={10}> 
                        <Form.Item
                          {...field}
                          name={[field.name, "name"]}
                          key={[field.key, "name"]}
                          rules={[
                            {
                              required: true,
                              message: t("Modules.Staff.StaffForm.pleaseEnterSubCategory"),
                            },
                          ]}
                          style={{ width: "100%" }}
                        >
                          <Input
                            placeholder={`${t("Modules.Staff.StaffForm.enterSubCategory")} ${index + 1}`}
                            onChange={(e) =>
                              onSubCategoryChange(index, "name", e.target.value)
                            }
                          />
                        </Form.Item>
                          </Col>
                          <Col span={10}>
                        <Form.Item
                          {...field}
                          name={[field.name, "name_ar"]}
                          key={[field.key, "name_ar"]}
                          rules={[
                            {
                              required: true,
                              message: `${t("Modules.Staff.StaffForm.pleaseEnterSubCategory")} ${t("CommonUtils.inArabic")}`,
                            },
                          ]}
                          style={{ width: "100%" }}
                        >
                          <Input
                            placeholder={`${t("Modules.Staff.StaffForm.enterSubCategory")} ${index + 1} ${t("CommonUtils.inArabic")}`}
                            dir="rtl"
                            onChange={(e) =>
                              onSubCategoryChange(
                                index,
                                "name_ar",
                                e.target.value
                              )
                            }
                          />
                        </Form.Item>
                        </Col>
                        <Button
                          type="danger"
                          onClick={() => remove(field.name)}
                        >
                          {t("CommonUtils.remove")}
                        </Button>
                        </Row>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => {
                          add();
                          setSubCategories([
                            ...subCategories,
                            { name: "", name_ar: "" },
                          ]);
                        }}
                      >
                        {t("CommonUtils.add")} {t("CommonUtils.subCategory")} 
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form.Item>

            {/* <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  style={{ width: "100%" }}
                  name="isActive"
                  label={<RequiredLabel text={t("active")} required={true} />}
                  valuePropName="checked"
                >
                  <Switch defaultChecked />
                </Form.Item>
              </Col>
            </Row> */}
          </Card>
          <Flex gap="1rem" align="center" justify="center">
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginTop: "1rem" }}
              loading={loading}
              disabled={loading}
            >
              {t("CommonUtils.submit")}
            </Button>
          </Flex>
        </Flex>
      </Form>
    </Modal>
  );
};

export default CategoriesFormDialog;
